export enum OsTypeEnum {
  Android = 1,
  IOs,
  Web,
}
